'use strict';

var TextEncoder = global.TextEncoder ? global.TextEncoder // browser
: require('text-encoding').TextEncoder; // node shim
module.exports = TextEncoder;


//////////////////
// WEBPACK FOOTER
// ../solid-auth-oidc/~/jose/lib/text-encoder/index.js
// module id = 114
// module chunks = 0